import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { pageKey } from '@dashboard/lib/queryKeys';

export function useStaffInviteMessage(pageId: string, initialMessage: string) {
  const { token } = useAuth();
  const qc = useQueryClient();

  type PageCache = { eventDetails?: { staffInviteMessage?: string } } & Record<string, unknown>;
  const m = useMutation({
    mutationFn: (message: string) =>
      fetcher(`/scanner/${pageId}/staff-invite-message`, token, {
        method: 'PATCH',
        body: JSON.stringify({ message }),
      }).then((data: { message?: string } | undefined) => data?.message ?? message),
    onSuccess: saved => {
      qc.setQueryData<PageCache | undefined>(pageKey(pageId), old =>
        old
          ? {
              ...old,
              eventDetails: { ...(old.eventDetails ?? {}), staffInviteMessage: saved },
            }
          : old,
      );
    },
  });

  return {
    message: initialMessage,
    save: m.mutateAsync,
    isSaving: m.isPending,
  };
}
